// extracted by mini-css-extract-plugin
module.exports = {"markdownContainer":"MarkdownViewer__markdownContainer___2FJbT","materialIcons":"MarkdownViewer__materialIcons___1WSrJ"};